import React, {Component} from "react";
import {FaIcon} from "../FaIcon";
import {EditAgencyManagerLimitModal} from "./EditAgencyManagerLimitModal";

export class AdAccountRow extends Component {
    constructor(props) {
        super(props);

        this.state = {
            'adAccountData': props.adAccountData
        };

        this.handleAdAccountGiveAccess = this.handleAdAccountGiveAccess.bind(this);
        this.handleAgencyManagerLimitModified = this.handleAgencyManagerLimitModified.bind(this);
    }

    handleAgencyManagerLimitModified(agencyManagerLimitConfiguration) {
        const adAccountData = this.state.adAccountData;
        adAccountData.ad_spent_limit = agencyManagerLimitConfiguration;
        this.setState(
            {
                'adAccountData': adAccountData
            }
        );
    }

    render() {
        const rows = [];
        rows.push(this.renderThisAccount());
        const childAccountsRows = this.renderChildAccounts();
        return rows.concat(childAccountsRows);
    }

    renderChildAccounts() {
        if (!this.state.adAccountData.child_accounts)
            return "";

        const childAccounts = this.state.adAccountData.child_accounts;
        return childAccounts.map(adAccountData => (<AdAccountRow
            key={adAccountData.channel + adAccountData.account_id}
            adAccountData={adAccountData}
            canEditManagerAdSpentLimit={this.props.canEditManagerAdSpentLimit}
            canGiveAccessToAdAccounts={this.props.canGiveAccessToAdAccounts}
            adAccountGiveAccessModal={this.props.giveAccessAdAccountModal}
            level={parseInt(this.props.level, 10) + 1}
        />));
    }

    renderThisAccount() {
        return (
            <tr key={this.state.adAccountData.channel + this.state.adAccountData.account_id}>
                <td>{this.renderName()}</td>
                <td>{this.renderAmountSpentToday()}</td>
                {this.renderAdSpentLimitToday()}
                <td>{this.renderAmountSpentAllTime()}</td>
                {this.renderAdSpentLimitAllTime()}
                {/*<td>{this.renderChatInfo()}</td>*/}
                <td className="action-cell ">
                    {this.renderAdAccountActions()}
                </td>
            </tr>);
    }

    renderAmountSpentAllTime() {
        if (!this.state.adAccountData.amount_spent)
            return "";
        return this.state.adAccountData.amount_spent.formatted_total_all_time;
    }

    renderAmountSpentToday() {
        if (!this.state.adAccountData.amount_spent)
            return "";
        return this.state.adAccountData.amount_spent.formatted_total_today_at_timezone;
    }

    isManager() {
        return this.state.adAccountData.type === "MANAGER";
    }

    renderExclamationIcon() {
        // FEDE: Esto no se esta viendo bien. Habría que mejorarlo.
        return (
            <div className={"bu-cell-icon exclamation-triangle"}>
                <FaIcon iconName={"exclamation-triangle"}/>
                <div className="bu-tooltip">
                    <FaIcon iconName={"exclamation-triangle"}/>
                    <p className="tooltip-description">
                        Cuenta removida
                    </p>
                </div>
            </div>);
    }

    renderName() {
        const indent = this.isManager() ? "" : ("\u00A0\u00A0\u00A0\u00A0".repeat(this.props.level - 1))
        const removedIcon = this.state.adAccountData.removed ? this.renderExclamationIcon() : "";
        const updatedAt = this.state.adAccountData.amount_spent && this.state.adAccountData.amount_spent.formatted_last_successfully_update_at ? this.state.adAccountData.amount_spent.formatted_last_successfully_update_at : "";
        return <span className={this.props.level}
                     title={updatedAt}>{indent} {this.state.adAccountData.account_id} - {this.state.adAccountData.name}{removedIcon}</span>;
    }

    renderAdSpentLimitAllTime() {
        const data = this.state.adAccountData.ad_spent_limit;
        if (!data)
            return <td></td>;

        let progressToLimit = "";
        if(this.state.adAccountData.amount_spent) {
            const limit = this.state.adAccountData.ad_spent_limit.limit_all_time;
            const spent = this.state.adAccountData.amount_spent.total_all_time;
            progressToLimit = "["+parseInt(spent/limit*100, 10)+"%]";
        }

        return (<td>
            {data.formatted_limit_all_time}&nbsp;{progressToLimit}<br/>Pausar: {(data.pause_all_campaigns_on_limit_exceeded_all_time ? "Si" : "No")}
            {this.renderEditLimitIcon(data)}
        </td>)
    }

    renderAdSpentLimitToday() {
        const data = this.state.adAccountData.ad_spent_limit;
        if (!data || !this.state.adAccountData.ad_spent_limit.limit_today_at_timezone)
            return <td></td>;

        let progressToLimit = "";
        if(this.state.adAccountData.amount_spent) {
            const limit = this.state.adAccountData.ad_spent_limit.limit_today_at_timezone;
            const spent = this.state.adAccountData.amount_spent.total_today_at_timezone;
            progressToLimit = "["+parseInt(spent/limit*100, 10)+"%]";
        }

        return (<td>
            {data.formatted_limit_today_at_timezone}&nbsp;{progressToLimit}<br/>Pausar: {(data.pause_all_campaigns_on_limit_exceeded_today_at_timezone ? "Si" : "No")}
            {this.renderEditLimitIcon(data)}
        </td>)
    }

    renderEditLimitIcon(data) {
        if(!this.props.canEditManagerAdSpentLimit)
            return;

        return (<EditAgencyManagerLimitModal onAgencyManagerLimitModified={this.handleAgencyManagerLimitModified}
                                             agencyManagerLimitConfigurationId={data.agency_manager_limit_configuration_id}
                                             adSpentLimitAllTime={data.limit_all_time}
                                             adSpentLimitTodayAtTimezone={data.limit_today_at_timezone}
                                             managerId={this.state.adAccountData.account_id}
                                             pauseAllCampaignsOnLimitExceededAllTime={data.pause_all_campaigns_on_limit_exceeded_all_time}
                                             pauseAllCampaignsOnLimitExceededTodayAtTimezone={data.pause_all_campaigns_on_limit_exceeded_today_at_timezone}
                                             timezoneForTodayLimit={data.timezone_for_today_limit}
        />);
    }

    // renderChatInfo() {
    //     const data = this.state.adAccountData.chat
    //     if (!data)
    //         return "";
    //
    //     return "Si (" + data.chats_enabled.join("-") + ")";
    // }

    renderAdAccountActions() {
        const actions = []
        if (this.props.canGiveAccessToAdAccounts && !this.isManager()) {
            actions.push(this.renderCanGiveAccessToAdAccountsAction())
        }

        return (
            <div>
                <div style={{
                    display: "inline-block",
                    verticalAlign: "middle"
                }}>
                    {actions}
                </div>
            </div>
        )
    }

    renderCanGiveAccessToAdAccountsAction() {
        return (
            <button key={"give-access-" + this.state.adAccountData.id} onClick={this.handleAdAccountGiveAccess}><FaIcon
                iconName={"universal-access"}/></button>)
    }

    handleAdAccountGiveAccess() {
        this.props.adAccountGiveAccessModal.setAdAccount(this.state.adAccountData.channel, this.state.adAccountData.account_id);
        this.props.adAccountGiveAccessModal.toggle();
    }
}
